import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import { fileIcon } from 'Helpers/File';
import GetAppIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from 'Components/UI/Button';
import ConfirmationDialog from 'Components/UI/ConfirmationDialog';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
  },
  leftSide: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
  },
  leftSideIcon: {
    alignSelf: 'center',
    color: theme.palette.facet.accentBlue2,
  },
  leftSideText: {
    display: 'flex',
    flexFlow: 'column',
    flex: 1,
    justifyContent: 'space-between',
    marginLeft: theme.spacing(1),
  },
  rightSide: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    paddingRight: theme.spacing(1),
  },
  downloadIcon: {
    color: theme.palette.facet.accentBlue2,
    fontSize: '2rem',
  },
  fileName: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.primaryBlue,
  },
  fileDetails: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  deleteButton: {
    marginLeft: theme.spacing(2),
  },
});

const View = ({
  classes, fileName, createdAt, createdBy, fileURL, resource, onRemoveFile,
}) => {
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  return (
    <Box
      className={classes.root}
      debugColor="crimson"
    >
      {showConfirmDialog && <ConfirmationDialog
        onConfirm={async () => {
          await resource.delete();
          onRemoveFile();
          setShowConfirmDialog(false);
        }}
        onCancel={() => setShowConfirmDialog(false)}
        title={'Are you sure?'}
        message={'Are you sure you want to remove this delete this attachment?'}
        cancelLabel={'Cancel'}
        confirmLabel={'Delete'}
      />}
      <Box debugColor="coral" className={classes.leftSide}>
        <Box debugColor="dodgerBlue" className={classes.leftSideIcon}>
          <FontAwesome
            icon={fileIcon(fileName)}
            fontSize="2rem"
          />
        </Box>
        <Box debugColor="gold" className={classes.leftSideText}>
          <Typography variant="h6" className={classes.fileName}>
            {fileName}
          </Typography>
          <Typography variant="h6" className={classes.fileDetails}>
            {`Uploaded ${createdAt} by ${createdBy}`}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.rightSide}>
        <a
          href={fileURL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button
            className={classes.deleteButton}
            color="primary"
          >
            <GetAppIcon />
          </Button>

        </a>
        {onRemoveFile ? (
          <Button
            className={classes.deleteButton}
            onClick={() => { setShowConfirmDialog(true); }}
            color="red"
          >
            <DeleteIcon />
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  fileURL: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
  onRemoveFile: PropTypes.func.isRequired,

};

export default withStyles(styles)(View);
